import { createFileRoute } from '@tanstack/react-router';
import { LeaveModule } from '@/modules/ess/leave';

export const Route = createFileRoute('/(dashboard)/_dashboard/ess/leave/')({
  component: LeaveModule,
});
